<template>
  <h1>Orders on Wait</h1>

  <div class="content-section filters">

    <div class="alert alert-warning" role="alert">After setting filters or changing sorting order, click "Apply filters"
      to re-query the database</div>
    <div class="row">
      <div class="col-md-4">
        <FormKit
            type="datepicker"
            label="Start Date"
            v-model="selectedStartDate"
            format="DD/MM/YYYY"
            timezone="Europe/London"
            clearable
            :key="datepickerClearedKey"
        ></FormKit>
      </div>

      <div class="col-md-4">
        <FormKit
            type="datepicker"
            label="End Date"
            v-model="selectedEndDate"
            format="DD/MM/YYYY"
            timezone="Europe/London"
            clearable
            :key="datepickerClearedKey"
        ></FormKit>
      </div>
    </div>

    <div class="action-bar">
      <button @click="clearFilter" id="clearFilter">Clear filter</button>&#160;
      <button @click="exportZip" id="exportZip">Export Logs</button>&#160;
      <button @click="applyFilter" id="applyFilter1">Apply filter</button>
    </div>

    <div v-if="isListing">

      <easy-data-table
          v-model:server-options="serverOptions"
          :server-items-length="serverItemsLength"
          :headers="headers"
          :items="ordersWait"
          :search-field="searchField"
          :search-value="searchValue"
          :loading="loading"
          alternating
          border-cell
          buttons-pagination
          multi-sort
      >
        <template #header="header">
          <div class="customize-header">

            {{ header.text }}<br />

            <input v-if="header.value !== 'operations'" type="text" :id="'filter-' + header.value" @click.stop />
            <button v-else @click="applyFilter" id="applyFilter2">Apply filter</button>
          </div>
        </template>


        <template #item-orderid="item">
          <router-link :to="{ name: 'ViewOrder', params: { id: item.orderid } }">
            <div>{{ item.orderid }}</div>
          </router-link>
        </template>

        <template #item-timeplaced="item">
          {{formatDateTimeEN(item.timeplaced)}}
        </template>

        <template #item-datedue="item">
          {{formatDateEN(item.datedue)}}
        </template>

        <template #item-customer_name="item">
          <router-link :to="{ name: 'ViewCustomer', params: { id: item.customer_id } }">
            <div> {{item.firstname}} {{item.surname}}</div>
          </router-link>
        </template>

        <template #item-customer_id="item">
          <router-link :to="{ name: 'ViewCustomer', params: { id: item.customer_id } }">
            <div>{{ item.customer_id }}</div>
          </router-link>
        </template>

      </easy-data-table>
    </div>
  </div>
</template>


<script setup>
import {ref, watch} from "vue";
import OrderService from "@/services/OrderService";

const ordersWait =  ref([]);
const searchField = ref("datedue");
const searchValue = ref("");

const nowDate = new Date();
const currentDate = new Date(Date.UTC(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate()));
const defaultStartDate = new Date(new Date().setDate(currentDate.getDate() - 90));
const defaultEndDate = new Date(new Date().setDate(currentDate.getDate() + 7));

const selectedStartDate = ref(defaultStartDate);
const selectedEndDate = ref(defaultEndDate);
const datepickerClearedKey = ref(0);

const forceRenderDatepicker = () => {
  datepickerClearedKey.value += 1;
};
const headers = [
  { text: "Order ID", value: "orderid", sortable: true  },
  { text: "Customer Name", value: "customer_name", sortable: true  },
  { text: "Customer ID", value: "customer_id", sortable: true  },
  { text: "Date Placed", value: "timeplaced", sortable: true  },
  { text: "Date Due", value: "datedue", sortable: true  },
  { text: "Total items on wait", value: "numWait", sortable: true },

  { text: "Actions", value: "operations" }
];

const isListing = ref(true);

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
  page: 1,
  rowsPerPage: 25,
  //sortBy: ["datedue"],
  sortType: ["desc"],
  exportFormat: "none",
  start_date: defaultStartDate,
  end_date: defaultEndDate
});

const formatDateTimeEN = (date) => {
  //25/12/2023
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
  var formatDate = new Date(date).toLocaleDateString('en-GB', options);
  var formatTime = new Date(date).toLocaleTimeString('en-GB');
  return formatDate+' '+formatTime;
}

const formatDateEN = (date) => {
  //25/12/2023
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
  var formatDate = new Date(date).toLocaleDateString('en-GB', options);
  return formatDate;
}

const  createDateAsUTC = (date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
}
const loadFromServer = async () => {
  loading.value = true;
  const {
    serverCurrentPageItems,
    serverTotalItemsLength,
  } = await OrderService.searchOrdersWait(serverOptions.value);
  ordersWait.value = serverCurrentPageItems;
  serverItemsLength.value = serverTotalItemsLength;
  loading.value = false;
};

const applyFilter = (resetPage) => {
  let filters = {};
  let updateOptions = serverOptions.value;
  for (let i = 0; i < headers.length; i++) {
    const filterProperty = headers[i].value;
    if (filterProperty !== "operations") {
      filters[headers[i].value] = document.getElementById("filter-" + filterProperty).value;
    }
  }
  updateOptions.filters = filters;

  if (selectedStartDate.value !== "" && typeof selectedStartDate.value != "undefined") {
    selectedStartDate.value = createDateAsUTC(new Date(selectedStartDate.value));
    updateOptions.start_date = selectedStartDate.value;
  }
  if (selectedEndDate.value !== "" && typeof selectedEndDate.value != "undefined") {
    selectedEndDate.value = createDateAsUTC(new Date(selectedEndDate.value));
    updateOptions.end_date = selectedEndDate.value;
  }
  if (resetPage) {
    updateOptions.page = 1;
  }
  serverOptions.value = updateOptions;
  loadFromServer();
};

const exportZip = async () => {
  loading.value = true;
  await OrderService.downloadOrdersWait(serverOptions.value);
  loading.value = false;
};

const clearFilter = () => {
  let filters = {};
  for (let i = 0; i < headers.length; i++) {
    const filterProperty = headers[i].value;
    if (filterProperty !== "operations") {
      filters[headers[i].value] = "";
      document.getElementById("filter-" + filterProperty).value = "";
    }
  }

  const updateServerOptions = serverOptions.value;
  updateServerOptions.filters = filters;
  selectedStartDate.value = "";
  selectedEndDate.value = "";
  serverOptions.value = updateServerOptions;

  forceRenderDatepicker();
  loadFromServer();
};

// initial load
loadFromServer();

watch(() => serverOptions.value.page, () => {
  applyFilter(false)
});

</script>